import { useContext } from 'react'

import { UserFormContext } from '../context'

export function useGroup() {
  const {
    groups,
    loadingGroups: loading,
    listGroups
  } = useContext(UserFormContext)

  return {
    groups,
    loading,
    listGroups
  }
}
